import Box from "@mui/material/Box";
import { Controller, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ENTERPRISE_INTAKE_OTHER_PLACEHOLDER } from "../../../../i18n/keysTranslations";
import FieldBlock from "../../../PreActivation/components/FieldBlock";
import FieldError from "../../../PreActivation/components/FieldError";
import FieldHint from "../../../PreActivation/components/FieldHint";
import FieldLabel from "../../../PreActivation/components/FieldLabel";
import IntakeTextField from "../../../../components/Form/IntakeTextField";
import RadioGroup from "../../../PreActivation/components/RadioGroup";

const RadioWithOtherField = ({
  name,
  otherName,
  labelKey,
  hintKey,
  required = false,
  options,
  control,
  errors,
  readOnly,
}) => {
  const { t } = useTranslation();
  const value = useWatch({ control, name });

  return (
    <FieldBlock>
      <FieldLabel htmlFor={name} text={t(labelKey)} required={required} />
      {hintKey ? <FieldHint text={t(hintKey)} /> : null}
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <>
            <RadioGroup
              name={name}
              options={options}
              selectedValue={field.value}
              onChange={field.onChange}
              readOnly={readOnly}
            />
            <FieldError message={fieldState.error?.message} />
          </>
        )}
      />
      {value === "other" ? (
        <Box sx={{ mt: 1 }}>
          <IntakeTextField
            name={otherName}
            control={control}
            rules={{}}
            errors={errors}
            fullWidth
            readOnly={readOnly}
            placeholder={t(ENTERPRISE_INTAKE_OTHER_PLACEHOLDER)}
            variant="outlined"
          />
        </Box>
      ) : null}
    </FieldBlock>
  );
};

export default RadioWithOtherField;
